export const SET_COMPANIES = 'SetCompanies';
export const SET_EMPLOYEES = 'SetEmployees';
export const SET_POSITIONS = 'SetPositions';
export const SET_COMPANIES_BY_PERMISSION = 'SetCompaniesByPermission';
export const SET_COMPANIES_BY_FEATURE = 'SetCompaniesByFeature';
export const SET_SERVICE_DEPARTMENTS = 'SetServiceDepartments';
export const SET_PROCESS_TRIGGER_RESPONSE = 'SetProcessTriggersResponse';
